export default __webpack_public_path__ + "static/media/steve.9652babc.webp";